import React from "react";
import {
  Box,
  Container,
  IconButton,
  Paper,
  SxProps,
  Typography,
  useTheme,
} from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import {
  FooterMainContent,
  Information,
  InternationalMemberships,
  PaymentOptions,
  PopularProducts,
  Social,
} from "./FooterComponents";
import { useTranslations } from "hooks/useTranslations";
import { IFooter } from "hooks/translations.interfaces";
import { Logo } from "@thekilroygroup/shared-ui";
export const DesktopFooter = () => {
  const { translations } = useTranslations();
  const footerTranslations: IFooter = translations.newFooter;
  const domainTrans = translations.domainInfo.footer;
  const { palette } = useTheme();

  const scrollToTop = () => {
    window.scrollTo({
      behavior: "smooth",
      top: 0,
    });
  };

  return (
    <Box sx={sx.root}>
      <Container maxWidth="lg">
        <Paper sx={sx.footerPaper}>
          <Box sx={sx.footerPaperTop}>
            <FooterMainContent
              title={footerTranslations.title}
              description={footerTranslations.description}
              cta={footerTranslations.ctaTitle}
              ctaUrl={footerTranslations.ctaLink}
            />
            <PopularProducts popularProducts={domainTrans.popularProducts}>
              <Typography variant="titleMedium" weight="bold" sx={sx.listTitle}>
                {footerTranslations.popularProductsTitle}
              </Typography>
            </PopularProducts>

            <Information information={domainTrans.additionalInformation}>
              <Typography variant="titleMedium" weight="bold" sx={sx.listTitle}>
                {footerTranslations.additionalInformationTitle}
              </Typography>
            </Information>
            <Social social={domainTrans.socialMedia}>
              <Typography variant="titleMedium" weight="bold" sx={sx.listTitle}>
                {footerTranslations.socialMediaTitle}
              </Typography>
            </Social>

            <IconButton
              onClick={scrollToTop}
              sx={{ height: "fit-content", color: "primary.main" }}
            >
              <ArrowUpwardIcon />
            </IconButton>
          </Box>
          <Box sx={sx.footerPaperBottom}>
            <Box sx={sx.footerPaperBottomWrapper}>
              <PaymentOptions paymentOptions={domainTrans.paymentOptions} />
            </Box>
            <Box sx={sx.footerPaperBottomWrapper}>
              <InternationalMemberships
                memberships={domainTrans.internationalMembershipsAssociations}
              />
            </Box>
          </Box>
        </Paper>
      </Container>
      <Container maxWidth="lg" sx={sx.logoContainer}>
        <Box>
          <Logo height={56} color={palette.white.main} />

          <Typography sx={sx.white} variant="titleMedium" weight="bold">
            {domainTrans.copyrights}
          </Typography>
        </Box>
        <Box>
          <Box>
            <Typography sx={sx.white} variant="bodyMedium" weight="bold">
              {domainTrans.address}
            </Typography>
            <Typography sx={sx.white} variant="bodyMedium" weight="bold">
              {footerTranslations.cvrNumber}: {domainTrans.cvrNumber}
            </Typography>
            <Typography sx={sx.white} variant="bodyMedium" weight="bold">
              {footerTranslations.IATAnumber}: {domainTrans.IATAnumber}
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

const sx: { [key: string]: SxProps } = {
  root: {
    py: 3.5,
    backgroundColor: "primary.main",
    zIndex: 1,
  },
  footerPaper: {
    boxShadow: "none",
    p: 4,
    borderRadius: 0.5,
  },
  footerPaperTop: {
    display: "grid",
    gridTemplateColumns: "10fr 4fr 3fr 2fr 1fr",
    gap: { xs: 7, xl: 9.25 },
  },
  footerPaperBottom: {
    display: "flex",
    justifyContent: "space-between",
    mt: 17,
  },
  footerPaperBottomWrapper: {
    display: "flex",
  },
  listTitle: {
    color: "primary.main",
    mb: 2,
  },
  logoContainer: {
    flexDirection: "row",
    display: "flex",
    justifyContent: "space-between",
    mt: 12.5,
  },
  white: {
    color: "white.main",
  },
};
